export const sources={};export const img={src:"__VITE_ASSET__9i17u1nN6xOO2zERFy_0aw__",w:640,h:640};export default{sources:sources,img:img};